import { ref } from '@vue/composition-api'
import http from 'services/http'

const useOrganizationRegistrationList = ({ organizationId } = {}) => {
  const registrations = ref([])
  const registrationsCount = ref(0)

  const organizationIdRef = ref(organizationId)
  const setOrganizationId = (organizationId) => {
    organizationIdRef.value = organizationId
  }
  const fetchRegistrations = async (params = { page: 1, status: 'all' }) => {
    const isOrg = !!organizationIdRef.value

    if (isOrg) {
      params = {
        ...params,
        status: 'all',
      }
    }

    const url = isOrg
      ? `/admin/organizations/${organizationIdRef.value}/registrations`
      : '/admin/recently-registered-organizers'
    const res = await http.getAuthed(url, params)
    registrations.value = res.data.results
    registrationsCount.value = res.data.count
    return res.data.results
  }

  const approveRegistrationInProgress = ref(false)
  const approveRegistration = async ({ userId, organizationId }) => {
    if (approveRegistrationInProgress.value) {
      console.warn('another approve is still in progress')
      return
    }
    approveRegistrationInProgress.value = true
    const sleep = http.sleep(1000)
    await http.postAuthed('/admin/approve-organizer-registration', {
      user_id: userId,
      organization_id: organizationId,
    })
    await sleep
    await fetchRegistrations()
    approveRegistrationInProgress.value = false
  }

  const rejectRegistrationInProgress = ref(false)
  const rejectRegistration = async ({ userId, organizationId }) => {
    if (rejectRegistrationInProgress.value) {
      console.warn('another reject is still in progress')
      return
    }
    rejectRegistrationInProgress.value = true
    const sleep = http.sleep(1000)
    await http.postAuthed('/admin/reject-organizer-registration', {
      user_id: userId,
      organization_id: organizationId,
    })
    await sleep
    await fetchRegistrations()
    rejectRegistrationInProgress.value = false
  }

  const hideRegistrationInProgress = ref(false)
  const hideRegistration = async ({ userId, organizationId }) => {
    if (hideRegistrationInProgress.value) {
      console.warn('another hide is still in progress')
      return
    }
    hideRegistrationInProgress.value = true
    await http.postAuthed('/admin/hide-organizer-registration', {
      user_id: userId,
      organization_id: organizationId,
    })
    await fetchRegistrations()
    hideRegistrationInProgress.value = false
  }

  return {
    registrations,
    registrationsCount,
    fetchRegistrations,
    approveRegistrationInProgress,
    approveRegistration,
    rejectRegistrationInProgress,
    rejectRegistration,
    hideRegistrationInProgress,
    hideRegistration,
    setOrganizationId,
  }
}

export default useOrganizationRegistrationList
